// extracted by css-extract-rspack-plugin
export default {"chart":"MenuChart-module__chart____uVUd","download":"MenuChart-module__download___GhORb","heatmap":"MenuChart-module__heatmap___kU9Fv"};